<template>
    <faq-questions :category="category" :items="items" :key="category.title">
        <template slot="icon">
            <img class="faq__introImage faq__introImage--sm" :src="image" :alt="category.image.alt">
        </template>
    </faq-questions>
</template>

<script>
import FaqService from '@/services/faq/FaqService';
import FaqQuestions from '@/components/partials/faq/FaqQuestions';

let faqService = new FaqService();

export default {
    name: 'FaqAnswers',
    data() {
        return {
            items: [],
            category: {
                title: '',
                description: '',
                image: {
                    filename: 'faq.png',
                },
            },
        };
    },
    methods: {
        /**
         * Loads FAQs answers and category based on the path.
         *
         * @param {String} path
         *
         * @returns {void}
         */
        loadFaq: function(path) {
            faqService.getAnswersByPath(path).then((response) => { this.items = response; });
            faqService.getCategoryByPath(path).then((response) => { this.category = response; });
        },
    },
    mounted: function() {
        this.loadFaq(this.$router.currentRoute.path);
    },
    computed: {
        image: function() {
            return require(`@/assets/images/pages/faq/icons/${this.category.image.filename}`);
        },
    },
    components: { FaqQuestions },
    watch: {
        '$route'(to) {
            this.loadFaq(to.path);
        },
    },
};
</script>
